import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, ShieldCheck } from 'lucide-react';
export function Pricing() {
  const includes = ['Guía Maestra InstaPrint AI', 'Prompt Library Master (50+ comandos)', 'La Fórmula de los 5 Elementos', 'Guía de Nichos de Oro', 'Checklist de Configuración'];
  return <section id="pricing" className="py-20 md:py-32 bg-lavender/10 px-4 sm:px-6 lg:px-8 space-y-[10px]" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <FadeIn data-id="element-162">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-lavender/30" data-id="element-163">
            <div className="md:flex" data-id="element-164">
              {/* Left side - Content */}
              <div className="p-8 md:p-12 md:w-3/5" data-id="element-165">
                <h2 className="text-3xl font-heading font-bold text-darkText mb-4" data-id="element-166">
                  Obtén el sistema completo InstaPrint AI hoy mismo.
                </h2>
                <p className="text-lightText mb-8" data-id="element-167">
                  Empieza a construir tu libertad financiera desde la mesa de tu
                  comedor con el poder de la Inteligencia Artificial.
                </p>

                <div className="space-y-4 mb-8" data-id="element-168">
                  <p className="font-bold text-darkText text-sm uppercase tracking-wider" data-id="element-169">
                    Lo que incluye:
                  </p>
                  {includes.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-170">
                      <Check className="w-5 h-5 text-peach flex-shrink-0" data-id="element-171" />
                      <span className="text-lightText" data-id="element-172">{item}</span>
                    </div>)}
                </div>
              </div>

              {/* Right side - Price */}
              <div className="bg-cream p-8 md:p-12 md:w-2/5 flex flex-col justify-center items-center text-center border-t md:border-t-0 md:border-l border-lavender/20 relative" data-id="element-173">
                <div className="absolute -top-3 right-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md animate-pulse" data-id="element-174">
                  -76% OFF
                </div>
                <p className="text-sm font-bold text-lightText uppercase tracking-wider mb-2" data-id="element-175">
                  Pago Único
                </p>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-176">
                  <span className="text-2xl text-lightText line-through decoration-red-400 decoration-2" data-id="element-177">
                    $27.00
                  </span>
                </div>
                <div className="flex items-start justify-center mb-2" data-id="element-178">
                  <span className="text-2xl font-bold text-peach mt-2" data-id="element-179">$</span>
                  <span className="text-6xl font-heading font-bold text-peach" data-id="element-180">
                    6
                  </span>
                  <span className="text-xl font-bold text-peach mt-8" data-id="element-181">.39</span>
                </div>
                <p className="text-xs text-green-600 font-semibold mb-4" data-id="element-182">
                  🔥 ¡Oferta por tiempo limitado!
                </p>

                <a id="pricing-cta" href="https://casaencalma.com/cart/51325803168039:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full py-4 px-6 text-lg font-bold text-white bg-peach hover:bg-peachHover transition-colors rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-300 mb-4" data-id="element-183">
                  ¡SÍ, QUIERO EMPEZAR MI TIENDA DE IA AHORA!
                </a>

                <div className="flex items-center justify-center gap-2 text-sm text-lightText" data-id="element-184">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-185" />
                  <span data-id="element-186">Pago 100% seguro</span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}